module.exports = __webpack_public_path__ + "static/media/Promo_Card_1.85a69b0c.png";